







import Vue from 'vue'
import TraceInfo from './TraceInfo.vue'
export default {
    name: "connectioninfolist",
    computed: {
        traces() {
            return this.$store.getters.getFiles;   
        }
    },
    components: {
        TraceInfo
    }
}
